import { render, staticRenderFns } from "./tnc-kh.vue?vue&type=template&id=f93d959c&scoped=true"
import script from "./tnc-kh.vue?vue&type=script&lang=js"
export * from "./tnc-kh.vue?vue&type=script&lang=js"
import style0 from "./tnc-kh.vue?vue&type=style&index=0&id=f93d959c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93d959c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f93d959c')) {
      api.createRecord('f93d959c', component.options)
    } else {
      api.reload('f93d959c', component.options)
    }
    module.hot.accept("./tnc-kh.vue?vue&type=template&id=f93d959c&scoped=true", function () {
      api.rerender('f93d959c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-kh.vue"
export default component.exports